import ModuleHomeUrl from 'dashboard/leftSideDrawer/ModuleHomeUrl';

import { OhsUser } from '../../user/OhsUser';
import OhsBreadcrumbsNameAndRef from './OhsBreadcrumbsNameAndRef';

const OhsBreadcrumbInjury = (
  ohsBreadcrumbsNameAndRef: OhsBreadcrumbsNameAndRef,
  modulePath: string,
  subPath: string,
  viewPath: string,
  operationPath: string,
  user: OhsUser
) => {
  const defaultModuleRef = {
    href: (ModuleHomeUrl[user.tier.type] as any).injurymgmt,
    name: user.configs.injurymgmt?.TITLE ?? 'Injury Management',
  };

  if (subPath === 'home') {
    ohsBreadcrumbsNameAndRef.leafName = {
      name: defaultModuleRef?.name,
    };
  } else if (
    viewPath === 'add' ||
    (subPath === 'record' && operationPath.indexOf('add') > -1) ||
    (subPath === 'template' && operationPath.indexOf('add') > -1)
  ) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Add' };
  } else if (operationPath.indexOf('edit') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    let viewHref = `/${modulePath}/${subPath}/${viewPath}/view`;
    if (subPath === 'record') {
      const operationParts = operationPath.split('/').filter(Boolean);
      const recordId = operationParts[operationParts.length - 1];
      viewHref = `/${modulePath}/${subPath}/${recordId}/view`;
    } else if (subPath === 'template' && viewPath === 'task-form') {
      const operationParts = operationPath.split('/').filter(Boolean);
      const taskId = operationParts[2];
      viewHref = `/${modulePath}/${subPath}/${viewPath}/${taskId}/view`;
    }
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: viewHref,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Edit' };
  } else if (operationPath.indexOf('view') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.leafName = { name: 'View' };
  } else if (operationPath.indexOf('completed') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/${viewPath}/view`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Evidence' };
  } else if (operationPath.indexOf('sign-off') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModuleRef;
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/${viewPath}/view`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Signoff' };
  }
  return ohsBreadcrumbsNameAndRef;
};
export default OhsBreadcrumbInjury;
